import { showModalCandyDispatchActionCreator } from "../Core/ModalManager/FormModalAction";
import { CandyThunkAction } from "../Core/Store/CandyReduxTypes";

export function showZeroReportModalActionCreator(): CandyThunkAction {
    return showModalCandyDispatchActionCreator({ modalName: "ZeroReport", acceptFiles: [] });
}
